import { NODE_ENV } from '@witmetrics/utils/constants';
import { getEnv } from '@witmetrics/utils/env';

const BASE_URL = 'witmetrics.io';
const LOCAL_URL = 'http://localhost';

export const getApiUrl = () => {
  return getUrl(3333, 'api', '/v1');
};

export const getAuthUrl = () => {
  return getUrl(3100, 'auth');
};

export const getAccountsUrl = () => {
  return getUrl(3200, 'accounts');
};

export const getAdminUrl = () => {
  return getUrl(3300, 'admin');
};

export const getCrmUrl = () => {
  return getUrl(3400, 'crm');
};

export const getPerspectiveUrl = () => {
  return getUrl(3500, 'perspective');
};

export const getUnisonUrl = () => {
  return getUrl(3600, 'unison');
};

export const getInsightsUrl = () => {
  return getUrl(3700, 'insights');
};

export const getSchedulerUrl = () => {
  return getUrl(3800, 'scheduler');
};

function getUrl(port: number, subdomain: string, path: string = '') {
  const env = getEnv();
  switch (env) {
    case NODE_ENV.DEVELOPMENT:
      return `${LOCAL_URL}:${port}${path}`;
    case NODE_ENV.TESTING:
      return `https://${subdomain}.testing.${BASE_URL}${path}`;
    case NODE_ENV.PRODUCTION:
      return `https://${subdomain}.${BASE_URL}${path}`;
    default:
      throw Error(`Unrecognized environment: "${env}"`);
  }
}

export const getProfilePicUrl = (source: string) => {
  return `${getApiUrl()}/files/profile-picture?key=${encodeURIComponent(
    source
  )}`;
};

export const getPracticeLogoUrl = (source: string) => {
  return `${getApiUrl()}/files/practice-logo/${encodeURIComponent(source)}`;
};
